export const APP_PATHS = {
  landing: '/',
  login: '/login',
  projects: '/projects',
  skills: '/skills',
  team: '/team',
} as const;

export function sanitizeInternalReturnUrl(
  value: string | null,
  fallback: string = APP_PATHS.projects,
): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return fallback;
  }

  return value;
}

export function buildLoginUrl(returnUrl: string): string {
  return `${APP_PATHS.login}?returnUrl=${encodeURIComponent(returnUrl)}`;
}

export function buildLocationReturnUrl(location: { pathname: string; search: string }): string {
  return `${location.pathname}${location.search}`;
}

export function getLegacyProjectTarget(search: string): string | null {
  const searchParams = new URLSearchParams(search);

  if (!searchParams.has('projectKey') && !searchParams.has('sessionId')) {
    return null;
  }

  return `${APP_PATHS.projects}${search}`;
}
